export default __webpack_public_path__ + "static/media/36I-114292_-21039_0.c6d4ca31.jpg";